export default __webpack_public_path__ + "static/bioregion_rubus_spectabilis-eebe9d82cd67af809d4c5ba00fb5cd6a.jpg";